export default {"src":"/_next/static/media/404-artwork.fb8f99e6.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};